// angular import
import { Component, output, signal } from '@angular/core';

// project import
import { NavLogo } from './nav-logo/nav-logo';
import { NavContent } from './nav-content/nav-content';
import { SharedModule } from 'src/app/shared/shared/shared-module';

@Component({
  selector: 'app-navigation',
  imports: [SharedModule, NavLogo, NavContent],
  templateUrl: './navigation.html',
  styleUrls: ['./navigation.scss']
})
export class Navigation {
  // public props
  menuState = signal<'expanded' | 'collapsed' | 'hovered'>('expanded');

  NavCollapse = output();
  NavCollapsedMob = output();
  navCollapsed: boolean;
  navCollapsedMob: boolean;
  windowWidth: number;

  // constructor
  constructor() {
    this.windowWidth = window.innerWidth;
    this.navCollapsedMob = false;
  }

  // public method
  navCollapse() {
    if (this.windowWidth >= 992) {
      this.navCollapsed = !this.navCollapsed;
      this.NavCollapse.emit();
    }
  }

  navCollapseMob() {
    if (this.windowWidth < 992) {
      this.NavCollapsedMob.emit();
    }
  }

  setMenuStateOnLeave() {
    if (this.navCollapsed)
      this.menuState.set('collapsed');
    else
      this.menuState.set('expanded');
  }
}
